<template>
	<div>
		<el-tabs type="card" v-model="tagConfig">

			<el-tab-pane label="Config" name="tab-cadastro">
				<span slot="label"><i class="fa fa-list-alt"></i> Informações Cadastrais</span>

				<ed-form :data="formData" :config="config" :response="response" :itens="parceiroItems">
					<div slot="form-footer"></div>
				</ed-form>
			</el-tab-pane>

			<el-tab-pane label="Fator de Risco desse Laboratório" name="tab-exames"  v-if="formData.id>0">
				<span slot="label"><i class="fa fa-exclamation-triangle"></i> Fator de Risco desse Laboratório</span>
				<FatorRisco :laboratorio="formData"/>
			</el-tab-pane>

			<!-- <el-tab-pane label="Config" name="tab-usuarios"  v-if="formData.id>0">
				<span slot="label"><i class="fa fa-users"></i> Usuários</span>
				<Usuarios :credenciada="formData"/>
			</el-tab-pane> -->

		</el-tabs>
	</div>
</template>

<script>

	import Rest from 'common/rest'
	import EdForm from 'common/form'
	import FormItems  from './_form/parceiro-cadastrar'
	import FatorRisco from './fator-risco/index'

  	export default {
  		name:"empresa",
  		components: {EdForm,FatorRisco},
  		mixins:[Rest],
  		data () {
		   	return {
				config:{
					estado:true,
					cnae:true,
					click:{
						save:this.salvar,
					},
					loading:{
						save:false,
					},
				},
				response:{},
				parceiroItems:[],
				formData:{
					id:this.$route.params.id,
				},
				tagConfig:'tab-cadastro'
			}
		},

		created(){
		},

		mounted: function() {
			this.parceiroItems = FormItems;
			this.getLaboratorio();
		},
		methods: {

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {

					self.config.loading.save = true;
					
                    self.delete('/laboratorio/deletar',{ids:data}).then((result)=>{
                        result = result[0];

                        self.config.loading.save = false;

                        if(result.status == 200){
							self.edMsg('Registo excluido com sucesso');
							self.getLaboratorio();
                        }
                    });

                });
			},

			getLaboratorio: function(){

				this.config.loading.save = true;
				this.response = {};

				this.get('laboratorio/'+this.$route.params.id).then((result)=>{
           			result = result[0];

					this.config.loading.save = false;
					this.response = {};

					if(result.status == 200){
						this.formData ={
							id:result.data.id,
							nome:result.data.nome,
							cnpj:result.data.cnpj,
							cei:result.data.cei,
							ie:result.data.ei,
							cnae:{cnae:result.data.cnae},
							cep:result.data.cep,
							id_estado:result.data.id_estado,
							id_cidade:result.data.id_cidade,
							end:result.data.end,
							num:result.data.num,
							comp:result.data.comp,
							bairro:result.data.bairro,
							tel_com:result.data.tel_com,
							tel_cel:result.data.tel_cel,
							email:result.data.email,
							site:result.data.site,
							obs:result.data.obs,
							resp:result.data.resp,
						};
					}
	       });
			},

			salvar: function(){
				
				this.config.loading.save = true;
				this.response = {};

				this.post('/laboratorio/editar',this.formData).then((result)=>{

					result = result[0];
						
					this.config.loading.save = false;
					this.response = result;
					
					if(result.status == 200){
						this.edMsg('Dados atualizados')
						this.getLaboratorio();
					}
				});
			}

		}
  	}
</script>


// WEBPACK FOOTER //
// editar.vue?0d455054